export const FIRST_WORKSHEET_HEADERS = [
  'LP. ',
  'baza',
  'glut',
  'otk',
  'kob',
  'xid',
  'nazwa_noss',
  'id_ksp',
  'nazwa_ksp',
  'wlas',
  'stat',
  'sz_geo',
  'dl_geo',
  'rodz',
  'szczudlo',
  'odciag',
  'przystawka',
  'i_podpor',
  'material',
  'przeglad',
  'woj',
  'powiat',
  'gmina',
  'adres',
  'id_gmina',
  'po weryfikacji',
  'Wydział ',
  'KOB',
  'status realizacji FZ (słownik)',
  'uwagi FZ '
];

export const SECOND_WORKSHEET_HEADERS = [
  'LP',
  'baza',
  'glut',
  'otk',
  'kob',
  'xid',
  'nazwa_noss',
  'id_ksp',
  'nazwa_ksp',
  'wlas',
  'stat',
  'sz_geo',
  'dl_geo',
  'rodz',
  'szczudlo',
  'odciag',
  'przystawka',
  'i_podpor',
  'material',
  'przeglad',
  'woj',
  'powiat',
  'gmina',
  'adres',
  'id_gmina',
  'po weryfikacji',
  'opis dodatkowy OTK /OPL ',
  'Wydział ',
  'KOB',
  'status realizacji FZ (słownik)',
  'uwagi FZ '
];

export const FIRST_WORKSHEET_COLUMN_WIDTHS = [
  10, 20, 10, 20, 10, 12, 20, 10, 20, 20, 20, 15, 15, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 10, 30, 30
];

export const SECOND_WORKSHEET_COLUMN_WIDTHS = [
  10, 20, 10, 20, 10, 12, 20, 10, 20, 20, 20, 15, 15, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20,
  20, 20, 20, 20, 10, 30, 30
];
